import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import type { NavGroupProps } from "Shared/Components/Layout/Full/Sidebar/NavCollapse";
import { ListItemButton, styled, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import type { ReactElement } from "react";
import { useLocation } from "react-router";

interface ListItemProps {
	open: boolean;
	level: number;
	menu?: NavGroupProps;
	children: ReactElement;
	onClick: () => void;
	selected: boolean;
}

export function ListItem({
	open,
	level,
	menu,
	onClick,
	selected,
	children,
}: ListItemProps) {
	const [themeConfiguration] = useAtom(themeAtom);
	const theme = useTheme();
	const { pathname } = useLocation();

	const ListItemStyled = styled(ListItemButton)(() => ({
		marginBottom: "2px",
		padding: "8px 10px",
		paddingLeft: level > 2 ? `${level * 15}px` : "10px",
		backgroundColor: open && level < 2 ? theme.palette.primary.main : "",
		whiteSpace: "nowrap",
		"&:hover": {
			backgroundColor:
				open && menu?.href && !pathname.includes(menu?.href)
					? theme.palette.primary.main
					: theme.palette.primary.light,
			color:
				menu?.href && pathname.includes(menu?.href)
					? theme.palette.primary.main
					: open
						? theme.palette.primary.light
						: theme.palette.primary.main,
		},
		color: (() => {
			if (menu?.href && pathname.includes(menu?.href)) {
				return theme.palette.primary.main;
			}
			if (open && level < 2) {
				return "white";
			}
			if (level > 1 && open) {
				return theme.palette.primary.main;
			}
			return theme.palette.text.secondary;
		})(),

		borderRadius: `${themeConfiguration.borderRadius}px`,
	}));

	return (
		<ListItemStyled onClick={onClick} selected={selected} disableRipple>
			{children}
		</ListItemStyled>
	);
}
